<template src="./index.html"></template>
<script>
	import minhead from '../../../../common/minHead/index.vue';
	import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
	import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
	import {
		getdata
	} from './data.js';
	import config from '../../../../../../configHttp.js';
	import uploadFile from '../../../../common/uploadFile/index.vue';
	import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
	import {
		getReportAdditionalInfo
	} from '../../../../../api/home.js';
	import {
		querycell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd,
		findConpanyConfig,
		get_info_by_no
	} from '../../../../../api/Draftgeneration.js';
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave
	} from '../../../../../api/bbmb.js';
	import {
		reportquerytrack
	} from '../../../../../api/xggj.js';
	import {
		zcfg_fycx,
		zcfg_fetch
	} from '../../../../../api/zcfg.js';
	import addzc from '../../../../common/addzc/index.vue';
	import seezc from '../../../../common/seezc/index.vue';
	import AdditionalTax_I from './AdditionalTax_I/index.vue';
	import AdditionalTax_II from './AdditionalTax_II/index.vue';
	import AdditionalTax_III from './AdditionalTax_III/index.vue';
	import AdditionalTax_IV from './AdditionalTax_IV/index.vue';
	import AdditionalTax_V from './AdditionalTax_V/index.vue';
	import AdditionalTax_VI from './AdditionalTax_VI/index.vue';
	import AdditionalTax_VII from './AdditionalTax_VII/index.vue';
	import AdditionalTax_VIII from './AdditionalTax_VIII/index.vue';
	import {
		getdata as getdataI
	} from './AdditionalTax_I/data.js';
	import {
		getdata as getdataV
	} from './AdditionalTax_V/data.js';
	import {
		getdata as getdataVI
	} from './AdditionalTax_VI/data.js';
	export default {
		name: '',
		components: {
			minhead,
			SalesTaxReportTree,
			SalesTaxReportbox,
			uploadFile,
			uploadFileplus,
			addzc,
			seezc,
			AdditionalTax_I,
			AdditionalTax_II,
			AdditionalTax_III,
			AdditionalTax_IV,
			AdditionalTax_V,
			AdditionalTax_VI,
			AdditionalTax_VII,
			AdditionalTax_VIII,
		},
		props: {
			type: {
				type: String,
				default: ''
			},
			params: {
				type: Object,
				default: {}
			},
			sbqj: {
				type: String,
				default: ''
			},
			showbox: {
				type: Boolean,
				default: false
			},
			mintext: {
				type: String,
				default: '填写'
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			seeNow: {
				type: Boolean,
				default: false
			},
			suosq: {
				type: String,
				default: ''
			}
		},
		data: function() {
			return {
				optionxfs: [],
				Changed: 0,
				start: '',
				stop: '',
				treestate: '',
				statedata: [],
				treedata: getdata().treedata,
				choosetitleindex: 'xfs_0',
				formlist: getdata().formlist,
				headobj: {},
				choosecellCode: '',
				smtext: '',
				zcdata: [],
				option: [{
						value: '30299',
						label: '水利建设专项收入'
					},
					{
						value: '39900',
						label: '其他收入'
					},
					{
						value: '30221',
						label: '建设行政事业性收费收入'
					}
				],
				searchlistzc: getdata().searchlistzc,
				headDatazc: getdata().headDatazc,
				pagination: getdata().pagination,
				seezcformlist: getdata().seezcformlist,
				formdatazc: getdata().formdatazc, //form表单数据
				//消费税及附加税费申报表
				tableDataI_I: [],
				tableDataI_II: [],
				//本期准予扣除税额计算表
				tableDataII_I: [],
				//本期减（免）税额计算表
				tableDataIII_I: [],
				//本期委托加工收回情况报告表
				tableDataIV_I: [],
				tableDataIV_II: [],
				//消费税附加税费计算表
				tableDataV_I: [],
				// 本期准予扣除税额计算表（成品油）
				tableDataVI_I: [],
				tableDataVI_II: [],
				// 烟批发企业月份销售明细清单
				tableDataVII_I: [],
				//卷烟生产企业合作生产卷烟消费税情况报告表
				tableDataVIII_I: [],
				IHead: [
					'xfs_0_x_0.1',
					'xfs_0_x_0.2',
					'xfs_0_x_1',
					'xfs_0_x_1D',
					'xfs_0_x_2',
					'xfs_0_x_3',
					'xfs_0_x_4',
					'xfs_0_x_4A',
					'xfs_0_x_5',
					'xfs_0_x_5B',
					'xfs_0_x_6',
					'xfs_0_x_6C',
				],
				IIHead: [
					'xfs_1_x_0',
					'xfs_1_x_1',
					'xfs_1_x_2',
					'xfs_1_x_3',
					'xfs_1_x_4',
					'xfs_1_x_5',
					'xfs_1_x_6',
					'xfs_1_x_7',
					'xfs_1_x_8',
					'xfs_1_x_9',
					'xfs_1_x_10',
					'xfs_1_x_11',
					'xfs_1_x_12',
					'xfs_1_x_13',
					'xfs_1_x_14',
					'xfs_1_x_15',
					'xfs_1_x_16',
					'xfs_1_x_17',
					'xfs_1_x_18',
					'xfs_1_x_19',
				],
				IIIHead: [
					'xfs_3_x_0',
					'xfs_3_x_1',
					'xfs_3_x_2',
					'xfs_3_x_2.1',
					'xfs_3_x_2.2',
					'xfs_3_x_3',
					'xfs_3_x_3.1',
					'xfs_3_x_3.2',
					'xfs_3_x_4',
					'xfs_3_x_5',
					'xfs_3_x_6',
					'xfs_3_x_7',
					'xfs_3_x_8',
				],
				IIIIHead: [
					'xfs_4_x_1.1',
					'xfs_4_x_1.2',
					'xfs_4_x_2',
					'xfs_4_x_3',
					'xfs_4_x_4',
					'xfs_4_x_5',
					'xfs_4_x_6',
					'xfs_4_x_7',
					'xfs_4_x_8',
					'xfs_4_x_9',
					'xfs_4_x_10',
					'xfs_4_x_11',
					'xfs_4_x_12',
				],
				IIIIIHead: [
					'xfs_4_x_1.1',
					'xfs_4_x_1.2',
					'xfs_4_x_2',
					'xfs_4_x_3',
					'xfs_4_x_4',
					'xfs_4_x_5',
					'xfs_4_x_6',
					'xfs_4_x_7',
				],
				IIIIIIHead: [
					'xfs_7_x_1',
					'xfs_7_x_2',
					'xfs_7_x_3',
					'xfs_7_x_4',
					'xfs_7_x_5',
					'xfs_7_x_6',
					'xfs_7_x_7',
					'xfs_7_x_8',
					'xfs_7_x_9',
					'xfs_7_x_10'
				],
				IIIIIIIHead: [
					'xfs_2_x_2',
					'xfs_2_x_3',
					'xfs_2_x_4',
					'xfs_2_x_5',
					'xfs_2_x_6',
					'xfs_2_x_7',
					'xfs_2_x_8',
				],
				IIIIIIIIHead: [
					'xfs_5_x_1',
					'xfs_5_x_2',
					'xfs_5_x_3',
					'xfs_5_x_4',
					'xfs_5_x_5',
					'xfs_5_x_6',
					'xfs_5_x_7',
					'xfs_5_x_8',
				],
				IIIIIIIIIHead: [
					'xfs_6_x_1',
					'xfs_6_x_2',
					'xfs_6_x_3',
					'xfs_6_x_4',
					'xfs_6_x_5',
					'xfs_6_x_6',
					'xfs_6_x_7',
					'xfs_6_x_8',
					'xfs_6_x_9',
					'xfs_6_x_10',
				],
				choosetable: '',
				chooseindex: '',
				choosecolum: '',
				delCellsI: [],
				ruleNum: "",
				errdiag: false,
				errarr: [],
			};
		},
		created() {},
		mounted() {
			get_info_by_no({
				companyNo: this.params.companyNo,
				shuibId: this.params.shuibId
			}).then(res => {
				this.optionxfs = [];
				let option = this.$optionxfs
				if (res.data.code == 1) {
					let data = res.data.data
					this.optionxfs = option.filter(item => data.map(v => v.pm).includes(item.value))
					this.optionxfs.forEach(v => {
						if (v.children) {
							v.children = v.children.filter(item => data.map(v => v.zm).includes(item
								.value))
						}
					})
				}
			})
			this.getReportAdditionalInfo();
			if (this.toseeUpdate) {
				this.getShuibDetailList();
			} else {
				this.manuscriptqueryReportStep();
			}
			window.test = this;
		},
		methods: {
			getReportAdditionalInfo() {
				getReportAdditionalInfo({
					id: this.params.id
				}).then((res) => {
					this.ruleNum = res.data.data.rule.ruleNum;
				});
			},
			//政策点击预览
			zcsclick(id) {
				this.$refs.boxref.zcsclick(id);
			},
			//选中格子
			forhover(table, colum, index) {
				this.$refs.boxref.forhover(table, colum, index);
			},
			//获取选中格子
			getchoosecellCode(table, colum, index) {
				if (this.$emptyandnull(table)) {
					this.choosecellCode = '';
					return false;
				}
				this.choosetable = table;
				this.chooseindex = index;
				this.choosecolum = colum;

				this.choosecellCode = this[table][index][colum].cellCode;
				if (this.toseeUpdate) {
					this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
					this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
				} else {
					this.smtext = this[table][index][colum]['updateDesc'] || '';
				}
			},
			//更正说明
			forgengzheng(table, colum, index, smtext) {
				this[table][index][colum]['updateDesc'] = smtext;
			},
			//更正政策和说明
			forxzsm(table, colum, index, smtext, zcdata) {
				this[table][index][colum]['map'] = {
					desc: '',
					zcs: []
				};
				this[table][index][colum]['map']['desc'] = smtext;
				this[table][index][colum]['map']['zcs'] = zcdata;
			},
			//点击全部范围
			refreshhover() {
				this.$nextTick(() => {
					this.$refs.boxref.refreshhover();
				});
			},
			getShuibDetailList() {
				getShuibDetailList({
					shuizId: this.params.shuizId,
					id: this.params.shuibId
				}).then((res) => {
					if (res.data.code == 1) {
						this.treedata = res.data.data;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			manuscriptqueryReportStep() {
				manuscriptqueryReportStep({
					id: this.params.id,
					sbbm: this.params.sbbm
				}).then((res) => {
					if (res.data.code == 1) {
						this.statedata = res.data.data.statusHistory;
						this.treedata = res.data.data.detail;
						if (this.treedata[0]) {
							this.getchoosetitleindex(this.treedata[0]);
						}
						this.querycell();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			getchoosetitleindex(item) {
				this.choosetitleindex = item.shuibNameCode;
			},
			//表格隐藏显示和返回
			forback() {
				if (this.Changed > 0) {
					this.$showConfirm({
						message: "是否不保存当前修改?",
						title: "您好未保存",
					}).then((res) => {
						if (res == "confirm") {
							this.$emit('forback', true);
						} else {
							//取消
						}
					});
				} else {
					this.$emit('forback', true);
				}
			},
			changestate(e) {
				this.treestate = e;
			},
			//传给后端值处理
			filternums(data, filterlist) {
				var newlist = [];
				filterlist.forEach((ytem) => {
					let newval = data.map((item) => {
						if (
							item[ytem] != undefined &&
							item[ytem] != 'undefined' &&
							this.$notemptyandnull(item[ytem]) &&
							item[ytem].cellVal != '合计'
						) {
							return item[ytem];
						} else {
							return 'x';
						}
					});
					newlist = [...newlist, ...newval].filter((gtem) => gtem != 'x');
				});
				return newlist;
			},
			//清空主表
			refreshtableDataI() {
				this.tableDataI_I.forEach((item, index) => {
					this.IHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});


				this.tableDataI_II.forEach((item, index) => {
					this.IHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//清空本期准予扣除税额计算表
			refreshtableDataII() {
				this.tableDataII_I.forEach((item, index) => {
					this.IIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//清空本期减（免）税额计算表
			refreshtableDataIII() {
				this.tableDataIII_I.forEach((item, index) => {
					this.IIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//清空本期委托加工收回情况报告表
			refreshtableDataIV() {
				this.tableDataIV_I.forEach((item, index) => {
					this.IIIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataIV_II.forEach((item, index) => {
					this.IIIIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//清空消费税附加税费计算表
			refreshtableDataV() {
				this.tableDataV_I.forEach((item, index) => {
					this.IIIIIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//清空本期准予扣除税额计算表（成品油）
			refreshtableDataVI() {
				this.tableDataVI_I.forEach((item, index) => {
					this.IIIIIIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
				this.tableDataVI_II.forEach((item, index) => {
					this.IIIIIIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//清空卷烟批发企业月份销售明细清单
			refreshtableDataVII() {
				this.tableDataVII_I.forEach((item, index) => {
					this.IIIIIIIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			//卷烟生产企业合作生产卷烟消费税情况报告表
			refreshtableDataVIII() {
				this.tableDataVIII_I.forEach((item, index) => {
					this.IIIIIIIIIHead.forEach((gtem) => {
						if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem]
							.cellVal != '- -') {
							item[gtem].cellVal = '';
							item[gtem].cellType = '';
						}
					});
				});
			},
			commanddcrefresh(e) {
				this.Changed++
				if (e == 'now') {
					if (this.choosetitleindex == 'xfs_0') {
						this.refreshtableDataI();
					}
					if (this.choosetitleindex == 'xfs_1') {
						this.refreshtableDataII();
					}
					if (this.choosetitleindex == 'xfs_3') {
						this.refreshtableDataIII();
					}
					if (this.choosetitleindex == 'xfs_4') {
						this.refreshtableDataIV();
					}
					if (this.choosetitleindex == 'xfs_7') {
						this.refreshtableDataV();
					}
					if (this.choosetitleindex == 'xfs_2') {
						this.refreshtableDataVI();
					}
					if (this.choosetitleindex == 'xfs_5') {
						this.refreshtableDataVII();
					}
					if (this.choosetitleindex == 'xfs_6') {
						this.refreshtableDataVIII();
					}
				}
				if (e == 'all') {
					Object.keys(this.headobj).map((key) => (this.headobj[key] = ''));
					this.refreshtableDataI();
					this.refreshtableDataII();
					this.refreshtableDataIII();
					this.refreshtableDataIV();
					this.refreshtableDataV();
					this.refreshtableDataVI();
					this.refreshtableDataVII();
					this.refreshtableDataVIII()
				}


			},
			//所有表格渲染
			querycell(index) {

				if (this.type == 'update') {
					querycell({
						companyNo: this.params.companyNo, // 公司编号
						id: this.params.id, //报表id
						shuibId: this.params.shuibId, //税种id
						sbbm: this.params.sbbm
					}).then((res) => {
						let dataarr = res.data.data;
						this.gettable(dataarr);
					});
				}
				if (this.type == 'tosee') {
					if (this.seeNow) {
						querycell({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm
						}).then((res) => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
						return false;
					}
					if (this.toseeUpdate) {
						querytemplatecell({
							shuibId: this.params.shuibId,
							id: this.params.id
						}).then((res) => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					} else {
						reportquerytrack({
							companyNo: this.params.companyNo, // 公司编号
							id: this.params.id, //报表id
							shuibId: this.params.shuibId, //税种id
							sbbm: this.params.sbbm,
							trackId: this.params.trackId
						}).then((res) => {
							let dataarr = res.data.data;
							this.gettable(dataarr);
						});
					}
				}
			},
			gettable(dataarr) {
				this.headobj = dataarr.head;
				if (dataarr.xfs_0) {
					let tableDataI_I = [{}]
					let xfs_0_X = dataarr.xfs_0.filter(item => parseInt(item.hanh) < 1000)
					if (xfs_0_X) {
						xfs_0_X = xfs_0_X.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh)).map(v => {
							v.disablednoty_xfs6 = true
							if (v.xfs_0_x_2 && v.xfs_0_x_2.cellVal != '- -' && !this.toseeUpdate) {
								v.xfs_0_x_2.cellVal = v.xfs_0_x_2.cellVal == '' ? '0.00' :
									`${this.$numMulti(v.xfs_0_x_2.cellVal, 100).toFixed(2)}`;
							}
							return v
						});
						tableDataI_I = [...tableDataI_I, ...xfs_0_X]
					}
					let xfs_1000 = dataarr.xfs_0.filter(item => parseInt(item.hanh) == 1000)
					if (xfs_1000) {
						xfs_1000[0].disablednoty_xfs6 = true
						xfs_1000[0].disablednoty_xfs6C = true
						tableDataI_I.push(xfs_1000[0])
					}
					this.tableDataI_I = tableDataI_I
					//
					var tableDataI_II = getdataI().tableDataII;
					tableDataI_II.forEach(v => {
						let xfs_0 = dataarr.xfs_0.filter(item => item.hanh == v.hanh)
						if (xfs_0) {
							v.xfs_0_x_1 = xfs_0[0].xfs_0_x_1 != undefined ?
								xfs_0[0].xfs_0_x_1 : {
									cellCode: "xfs_0_" + v.hanh + "_1",
									cellLaiy: "0",
									cellOldVal: "",
									cellType: "0",
									cellVal: "0",
									goujgxValue: null,
									id: null,
									map: null,
									reportId: null,
									updateDesc: ""
								}
							v.xfs_0_x_1D = xfs_0[0].xfs_0_x_1D != undefined ?
								xfs_0[0].xfs_0_x_1D : {
									cellCode: "xfs_0_" + v.hanh + "_1D",
									cellLaiy: "0",
									cellOldVal: "",
									cellType: "0",
									cellVal: "0",
									goujgxValue: null,
									id: null,
									map: null,
									reportId: null,
									updateDesc: ""
								}
						}
					})
					this.tableDataI_II = tableDataI_II
				}
				if (dataarr.xfs_1) {
					let tableDataII_I = [{}]
					let xfs_1_X = dataarr.xfs_1.filter(item => parseInt(item.hanh) < 1000)
					if (xfs_1_X) {
						xfs_1_X = xfs_1_X.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh)).map(v => {
							if (v.xfs_1_x_10 && v.xfs_1_x_10.cellVal != '- -' && !this.toseeUpdate) {
								v.xfs_1_x_10.cellVal = v.xfs_1_x_10.cellVal == '' ? '0.00' :
									`${this.$numMulti(v.xfs_1_x_10.cellVal, 100).toFixed(2)}`;
							}
							return v
						});
						tableDataII_I = [...tableDataII_I, ...xfs_1_X]
					}
					let xfs_1000 = dataarr.xfs_1.filter(item => parseInt(item.hanh) == 1000)
					if (xfs_1000) {
						tableDataII_I.push(xfs_1000[0])
					}
					this.tableDataII_I = tableDataII_I
				}
				if (dataarr.xfs_3) {
					let tableDataIII_I = [{}]
					let xfs_3_X = dataarr.xfs_3.filter(item => parseInt(item.hanh) < 1000)
					if (xfs_3_X) {
						xfs_3_X = xfs_3_X.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh)).map(v => {
							if (v.xfs_3_x_5 && v.xfs_3_x_5.cellVal != '- -' && !this.toseeUpdate) {
								v.xfs_3_x_5.cellVal = v.xfs_3_x_5.cellVal == '' ? '0.00' :
									`${this.$numMulti(v.xfs_3_x_5.cellVal, 100).toFixed(2)}`;
							}

							return v
						});
						tableDataIII_I = [...tableDataIII_I, ...xfs_3_X]
					}
					let xfs_1000 = dataarr.xfs_3.filter(item => parseInt(item.hanh) == 1000)
					if (xfs_1000) {
						tableDataIII_I.push(xfs_1000[0])
					}
					this.tableDataIII_I = tableDataIII_I
				}
				if (dataarr.xfs_4) {
					let tableDataIV_I = [{}]
					let xfs_4_X = dataarr.xfs_4.filter(item => parseInt(item.hanh) < 1000)
					if (xfs_4_X) {
						xfs_4_X = xfs_4_X.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh)).map(v => {
							if (v.xfs_4_x_6 && v.xfs_4_x_6.cellVal != '- -' && !this.toseeUpdate) {
								v.xfs_4_x_6.cellVal = v.xfs_4_x_6.cellVal == '' ? '0.00' :
									`${this.$numMulti(v.xfs_4_x_6.cellVal, 100).toFixed(2)}`;
							}
							return v
						});
						tableDataIV_I = [...tableDataIV_I, ...xfs_4_X]
					}
					this.tableDataIV_I = tableDataIV_I
					//
					let tableDataIV_II = [{}]
					let xfs_1000 = dataarr.xfs_4.filter(item => parseInt(item.hanh) > 1000)
					if (xfs_1000) {
						xfs_1000 = xfs_1000.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh));
						tableDataIV_II = [...tableDataIV_II, ...xfs_1000]
					}
					this.tableDataIV_II = tableDataIV_II
				}
				if (dataarr.xfs_7) {
					let tableDataV_I = getdataV().tableDataI
					dataarr.xfs_7.forEach(v => {
						this.IIIIIIHead.forEach(item => {
							if (item == 'xfs_7_x_2') {
								if (v.xfs_7_x_2 && v.xfs_7_x_2.cellVal != '- -' && !this.toseeUpdate) {
									v.xfs_7_x_2.cellVal = v.xfs_7_x_2.cellVal == '' ? '0.00' :
										`${this.$numMulti(v.xfs_7_x_2.cellVal, 100).toFixed(2)}`;
								}
							}
							if (item == 'xfs_7_x_7') {
								if (v.xfs_7_x_7 && v.xfs_7_x_7.cellVal != '- -' && !this.toseeUpdate) {
									v.xfs_7_x_7.cellVal = v.xfs_7_x_7.cellVal == '' ? '0.00' :
										`${this.$numMulti(v.xfs_7_x_7.cellVal, 100).toFixed(2)}`;
								}
							}
							tableDataV_I[v.hanh][item] = v[item]
						})
						tableDataV_I[v.hanh].hanh = v.hanh
					})
					this.tableDataV_I = tableDataV_I
				}
				if (dataarr.xfs_2) {
					let tableDataVI_I = getdataVI().tableDataI
					let tableDataVI_II = getdataVI().tableDataII
					let xfs_2 = dataarr.xfs_2.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh));
					xfs_2.forEach(v => {
						if (parseInt(v.hanh) < 7) {
							this.IIIIIIIHead.forEach(item => {
								if (v[item]) {
									tableDataVI_I[v.hanh][item] = v[item]
								}
							})
							tableDataVI_I[v.hanh].hanh = v.hanh
						} else {
							this.IIIIIIIHead.forEach(item => {
								if (v[item]) {
									tableDataVI_II[v.hanh - 6][item] = v[item]
								}
							})
							tableDataVI_II[v.hanh - 6].hanh = v.hanh
						}

					})
					this.tableDataVI_I = tableDataVI_I
					this.tableDataVI_II = tableDataVI_II
				}
				if (dataarr.xfs_5) {
					let tableDataVII_I = [{}]
					if (dataarr.xfs_5) {
						let xfs_5 = dataarr.xfs_5.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh));
						tableDataVII_I = [...tableDataVII_I, ...xfs_5]
					}
					this.tableDataVII_I = tableDataVII_I
				}
				if (dataarr.xfs_6) {
					let tableDataVIII_I = [{}]
					if (dataarr.xfs_6) {
						let xfs_6 = dataarr.xfs_6.sort((a, b) => parseInt(a.hanh) - parseInt(b.hanh));
						tableDataVIII_I = [...tableDataVIII_I, ...xfs_6]
					}
					this.tableDataVIII_I = tableDataVIII_I
				}
			},
			headchange(e) {
				this.headobj = e;
			},
			delCellsCode(e, Head) {
				this.delCellsI = [...this.filternums(e, this[Head]), ...this.delCellsI];
			},
			checkerror() {
				let arr = [];
				let treeCode = this.treedata.map((item) => item.shuibNameCode);
				if (treeCode.includes('xfs_0')) {
					let data = this.tableDataI_I.filter(item => parseInt(item.hanh) < 1000)
					data.forEach(item => {
						if (item['xfs_0_x_0.1'].cellVal == "" || item['xfs_0_x_0.1'].cellVal == '0' || item[
								'xfs_0_x_0.1'].cellVal == "- -") {
							arr.push("主表第" + item.hanh + "栏次应税消费品名称未选择")
						}
					})
				}
				if (treeCode.includes('xfs_1')) {
					let data = this.tableDataII_I.filter(item => parseInt(item.hanh) < 1000)
					data.forEach(item => {
						if (item['xfs_1_x_0'].cellVal == "" || item['xfs_1_x_0'].cellVal == '0' || item[
								'xfs_1_x_0'].cellVal == "- -") {
							arr.push("本期准予扣除税额计算表第" + item.hanh + "栏次应税消费品名称未选择")
						}
					})
				}
				if (treeCode.includes('xfs_3')) {
					let data = this.tableDataIII_I.filter(item => parseInt(item.hanh) < 1000)
					data.forEach(item => {
						if (item['xfs_3_x_1'].cellVal == "" || item['xfs_3_x_1'].cellVal == '0' || item[
								'xfs_3_x_1'].cellVal == "- -") {
							arr.push("本期减（免）税额计算表第" + item.hanh + "栏次应税消费品名称未选择")
						}
					})
				}
				if (treeCode.includes('xfs_4')) {
					let data = this.tableDataIV_I.filter(item => parseInt(item.hanh) < 1000)
					data.forEach(item => {
						if (item['xfs_4_x_1.1'].cellVal == "" || item['xfs_4_x_1.1'].cellVal == '0' || item[
								'xfs_4_x_1.1'].cellVal == "- -") {
							arr.push("本期委托加工收回情况报告表表第" + item.hanh + "栏次应税消费品名称未选择")
						}
					})
				}
				// if (treeCode.includes('xfs_7')) {

				// }
				if (arr.length > 0) {
					this.errarr = arr;
					this.errdiag = true;
					return false;
				} else {
					return true;
				}
			},
			forsave() {
				let status = this.checkerror();
				const newarr = [
					...this.filternums(this.tableDataI_I, this.IHead),
					...this.filternums(this.tableDataI_II, this.IHead),
					...this.filternums(this.tableDataII_I, this.IIHead),
					...this.filternums(this.tableDataIII_I, this.IIIHead),
					...this.filternums(this.tableDataIV_I, this.IIIIHead),
					...this.filternums(this.tableDataIV_II, this.IIIIIHead),
					...this.filternums(this.tableDataV_I, this.IIIIIIHead),
					...this.filternums(this.tableDataVI_I, this.IIIIIIIHead),
					...this.filternums(this.tableDataVI_II, this.IIIIIIIHead),
					...this.filternums(this.tableDataVII_I, this.IIIIIIIIHead),
					...this.filternums(this.tableDataVIII_I, this.IIIIIIIIIHead),
				];
				let xfs_0_x_2 = this.tableDataI_I.filter(item => parseInt(item.hanh) < 1000).map(v => v.xfs_0_x_2.cellCode)
				let xfs_1_x_10 = this.tableDataII_I.filter(item => parseInt(item.hanh) < 1000).map(v => v.xfs_1_x_10
					.cellCode)
				let xfs_3_x_5 = this.tableDataIII_I.filter(item => parseInt(item.hanh) < 1000).map(v => v.xfs_3_x_5
					.cellCode)
				let xfs_4_x_6 = this.tableDataIV_I.filter(item => parseInt(item.hanh) < 1000).map(v => v.xfs_4_x_6
					.cellCode)
				let xfs_7_x_7 = this.tableDataV_I.filter(item => parseInt(item.hanh) < 4).map(v => v.xfs_7_x_7.cellCode)
				let xfs_7_x_2 = this.tableDataV_I.filter(item => parseInt(item.hanh) < 4).map(v => v.xfs_7_x_2.cellCode)
				newarr.forEach(item => {
					if (item.cellCode && item.cellVal != '- -' &&
						(
							xfs_0_x_2.includes(item.cellCode) ||
							xfs_1_x_10.includes(item.cellCode) ||
							xfs_3_x_5.includes(item.cellCode) ||
							xfs_4_x_6.includes(item.cellCode) ||
							xfs_7_x_7.includes(item.cellCode) ||
							xfs_7_x_2.includes(item.cellCode)
						)) {
						item.cellVal = item.cellVal * (0.01).toFixed(2);
					}

				});

				let params = {
					cells: newarr,
					companyNo: this.params.companyNo,
					id: this.params.id,
					sbbm: this.params.sbbm,
					delCells: this.delCellsI,
					head: this.headobj,
					checkFlag: status
				};
				writesave(params).then((res) => {
					if (res.data.code == 1) {
						this.Changed = 0
						this.querycell();
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			inputblur(e, codename, listname) {
				this.Changed++
				let cellval = e.cellVal == '' ? '0.00' : e.cellVal;
				let oldcellval =
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal'] == '' ?
					'0.00' :
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal'];
				if (
					parseFloat(cellval).toFixed(2) != parseFloat(oldcellval).toFixed(2) &&
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
				) {
					this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
				}
				let code = e.cellCode.split("_")[e.cellCode.split("_").length - 1];
				// e.cellCode.substring(e.cellCode.length - 2, e.cellCode.length - 1) == '_' ?
				// e.cellCode.substring(e.cellCode.length - 1, e.cellCode.length) :
				// e.cellCode.substring(e.cellCode.length - 2, e.cellCode.length);
				let num = e.cellCode.split("_")[e.cellCode.split("_").length - 2];
				// e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2) == '_' ?
				// e.cellCode.substring(e.cellCode.length - code.length - 2, e.cellCode.length - code.length - 1) :
				// e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2);

				console.log(code)
				console.log(num)
				if (code == 1) {
					this.changetableval(
						`xfs_0_${num}_6`,
						`tableDataI_I`,
						this.gettableval(`xfs_0_${num}_1`, `tableDataI_I`) * this.gettableval(
							`xfs_0_${num}_4`,
							`tableDataI_I`) + (this.gettableval(`xfs_0_${num}_2`, `tableDataI_I`) * 0.01) * this
						.gettableval(
							`xfs_0_${num}_5`, `tableDataI_I`)
					);
					this.changetableval(
						`xfs_1_${num}_5`,
						`tableDataII_I`,
						this.gettableval(`xfs_1_${num}_1`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_2`,
							`tableDataII_I`) - this.gettableval(`xfs_1_${num}_3`, `tableDataII_I`) - this.gettableval(
							`xfs_1_${num}_4`, `tableDataII_I`)
					);
					this.changetableval(
						`xfs_7_${num}_3`,
						`tableDataV_I`,
						this.gettableval(`xfs_7_${num}_1`, `tableDataV_I`) * (this.gettableval(`xfs_7_${num}_2`,
							`tableDataV_I`) * 0.01)
					);
					this.changetableval(
						`xfs_0_1004_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1002_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1003_1`,
							`tableDataI_II`)
					);
					this.changetableval(
						`xfs_0_1005_1`,
						`tableDataI_II`,
						Math.min((this.gettableval(`xfs_0_1000_6`, `tableDataI_I`) - this.gettableval(`xfs_0_1001_1`,
							`tableDataI_II`)), this.gettableval(`xfs_0_1004_1`, `tableDataI_II`))
					);

					this.changetableval(
						`xfs_0_1006_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1004_1`, `tableDataI_II`) - this.gettableval(`xfs_0_1005_1`,
							`tableDataI_II`)
					);
					this.changetableval(
						`xfs_0_1008_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1000_6`, `tableDataI_I`) - this.gettableval(`xfs_0_1001_1`,
							`tableDataI_II`) - this.gettableval(`xfs_0_1005_1`, `tableDataI_II`) - this.gettableval(
							`xfs_0_1007_1`, `tableDataI_II`)
					);
					this.changetableval(
						`xfs_0_1001_1D`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1001_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1001_1D`,
							`tableDataI_II`, `old`)
					);
					this.changetableval(
						`xfs_0_1003_1D`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1003_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1003_1D`,
							`tableDataI_II`, `old`)
					);

					this.changetableval(
						`xfs_0_1005_1D`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1005_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1005_1D`,
							`tableDataI_II`, `old`)
					);

					this.changetableval(
						`xfs_0_1008_1D`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1008_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1008_1D`,
							`tableDataI_II`, `old`)
					);
					this.changetableval(
						`xfs_0_1009_1D`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1009_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1009_1D`,
							`tableDataI_II`, `old`)
					);
					this.changetableval(
						`xfs_0_1010_1D`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1010_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1010_1D`,
							`tableDataI_II`, `old`)
					);
					this.changetableval(
						`xfs_0_1011_1D`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1011_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1011_1D`,
							`tableDataI_II`, `old`)
					);
				}
				if (code == 2) {
					this.changetableval(
						`xfs_0_${num}_6`,
						`tableDataI_I`,
						this.gettableval(`xfs_0_${num}_1`, `tableDataI_I`) * this.gettableval(
							`xfs_0_${num}_4`,
							`tableDataI_I`) + (this.gettableval(`xfs_0_${num}_2`, `tableDataI_I`) * 0.01) * this
						.gettableval(
							`xfs_0_${num}_5`, `tableDataI_I`)
					);
					this.changetableval(
						`xfs_1_${num}_5`,
						`tableDataII_I`,
						this.gettableval(`xfs_1_${num}_1`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_2`,
							`tableDataII_I`) - this.gettableval(`xfs_1_${num}_3`, `tableDataII_I`) - this.gettableval(
							`xfs_1_${num}_4`, `tableDataII_I`)
					);
					this.changetableval(
						`xfs_7_${num}_3`,
						`tableDataV_I`,
						this.gettableval(`xfs_7_${num}_1`, `tableDataV_I`) * (this.gettableval(`xfs_7_${num}_2`,
							`tableDataV_I`) * 0.01)
					);
					this.changetableval(
						`xfs_0_1004_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1002_1`, `tableDataI_II`) + this.gettableval(`xfs_0_1003_1`,
							`tableDataI_II`)
					);
				}
				if (code == 3) {
					this.changetableval(
						`xfs_1_${num}_5`,
						`tableDataII_I`,
						this.gettableval(`xfs_1_${num}_1`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_2`,
							`tableDataII_I`) - this.gettableval(`xfs_1_${num}_3`, `tableDataII_I`) - this.gettableval(
							`xfs_1_${num}_4`, `tableDataII_I`)
					);


					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_I`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_I`) * this.gettableval(`xfs_4_${num}_5`,
							`tableDataIV_I`) + this.gettableval(`xfs_4_${num}_4`, `tableDataIV_I`) * (this
							.gettableval(`xfs_4_${num}_6`, `tableDataIV_I`) * 0.01)
					);
					this.changetableval(
						`xfs_4_${1000+parseInt(num)}_4`,
						`tableDataIV_II`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_I`)
					);
					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_II`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_II`) + this.gettableval(
							`xfs_4_${num}_4`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_5`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_6`, `tableDataIV_II`)
					);

					this.changetableval(
						`xfs_7_${num}_8`,
						`tableDataV_I`,
						(this.gettableval(`xfs_7_${num}_3`, `tableDataV_I`) - this.gettableval(`xfs_7_${num}_5`,
							`tableDataV_I`)) * (this.gettableval(`xfs_7_${num}_7`, `tableDataV_I`) * 0.01)
					);

					this.changetableval(
						`xfs_7_${num}_10`,
						`tableDataV_I`,
						this.gettableval(`xfs_7_${num}_3`, `tableDataV_I`) - this.gettableval(`xfs_7_${num}_5`,
							`tableDataV_I`) - this.gettableval(`xfs_7_${num}_8`, `tableDataV_I`) - this.gettableval(
							`xfs_7_${num}_9`, `tableDataV_I`)
					);

					this.xfs_7_4_3();
				}
				if (code == 4) {
					this.changetableval(
						`xfs_0_${num}_6`,
						`tableDataI_I`,
						this.gettableval(`xfs_0_${num}_1`, `tableDataI_I`) * this.gettableval(
							`xfs_0_${num}_4`,
							`tableDataI_I`) + (this.gettableval(`xfs_0_${num}_2`, `tableDataI_I`) * 0.01) * this
						.gettableval(
							`xfs_0_${num}_5`, `tableDataI_I`)
					);
					this.changetableval(
						`xfs_1_${num}_5`,
						`tableDataII_I`,
						this.gettableval(`xfs_1_${num}_1`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_2`,
							`tableDataII_I`) - this.gettableval(`xfs_1_${num}_3`, `tableDataII_I`) - this.gettableval(
							`xfs_1_${num}_4`, `tableDataII_I`)
					);
					if (num > 1) {
						this.changetableval(
							`xfs_3_${num}_8`,
							`tableDataIII_I`,
							this.gettableval(`xfs_3_${num}_4`, `tableDataIII_I`) * (this.gettableval(`xfs_3_${num}_5`,
								`tableDataIII_I`) * 0.01) + this.gettableval(`xfs_3_${num}_7`, `tableDataIII_I`) * this
							.gettableval(`xfs_3_${num}_6`, `tableDataIII_I`)
						);
					}
					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_I`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_I`) * this.gettableval(`xfs_4_${num}_5`,
							`tableDataIV_I`) + this.gettableval(`xfs_4_${num}_4`, `tableDataIV_I`) * (this
							.gettableval(`xfs_4_${num}_6`, `tableDataIV_I`) * 0.01)
					);

					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_II`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_II`) + this.gettableval(
							`xfs_4_${num}_4`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_5`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_6`, `tableDataIV_II`)
					);
					this.changetableval(
						`xfs_0_${num}_4A`,
						`tableDataI_I`,
						this.gettableval(`xfs_0_${num}_4`, `tableDataI_I`) + this.gettableval(`xfs_0_${num}_4A`,
							`tableDataI_I`, `old`)
					);
				}
				if (code == 5) {
					this.changetableval(
						`xfs_1_${num}_19`,
						`tableDataII_I`,
						this.gettableval(`xfs_1_${num}_5`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_11`,
							`tableDataII_I`) + this.gettableval(`xfs_1_${num}_18`, `tableDataII_I`)
					);
					this.changetableval(
						`xfs_0_${num}_6`,
						`tableDataI_I`,
						this.gettableval(`xfs_0_${num}_1`, `tableDataI_I`) * this.gettableval(
							`xfs_0_${num}_4`,
							`tableDataI_I`) + (this.gettableval(`xfs_0_${num}_2`, `tableDataI_I`) * 0.01) * this
						.gettableval(
							`xfs_0_${num}_5`, `tableDataI_I`)
					);
					if (num > 1) {
						this.changetableval(
							`xfs_3_${num}_8`,
							`tableDataIII_I`,
							this.gettableval(`xfs_3_${num}_4`, `tableDataIII_I`) * (this.gettableval(`xfs_3_${num}_5`,
								`tableDataIII_I`) * 0.01) + this.gettableval(`xfs_3_${num}_7`, `tableDataIII_I`) * this
							.gettableval(`xfs_3_${num}_6`, `tableDataIII_I`)
						);
					}
					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_I`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_I`) * this.gettableval(`xfs_4_${num}_5`,
							`tableDataIV_I`) + this.gettableval(`xfs_4_${num}_4`, `tableDataIV_I`) * (this
							.gettableval(`xfs_4_${num}_6`, `tableDataIV_I`) * 0.01)
					);
					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_II`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_II`) + this.gettableval(
							`xfs_4_${num}_4`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_5`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_6`, `tableDataIV_II`)
					);
					this.changetableval(
						`xfs_7_${num}_8`,
						`tableDataV_I`,
						(this.gettableval(`xfs_7_${num}_3`, `tableDataV_I`) - this.gettableval(`xfs_7_${num}_5`,
							`tableDataV_I`)) * (this.gettableval(`xfs_7_${num}_7`, `tableDataV_I`) * 0.01)
					);
					this.changetableval(
						`xfs_7_${num}_10`,
						`tableDataV_I`,
						this.gettableval(`xfs_7_${num}_3`, `tableDataV_I`) - this.gettableval(`xfs_7_${num}_5`,
							`tableDataV_I`) - this.gettableval(`xfs_7_${num}_8`, `tableDataV_I`) - this.gettableval(
							`xfs_7_${num}_9`, `tableDataV_I`)
					);
					this.changetableval(
						`xfs_0_${num}_5B`,
						`tableDataI_I`,
						this.gettableval(`xfs_0_${num}_5`, `tableDataI_I`) + this.gettableval(`xfs_0_${num}_5B`,
							`tableDataI_I`, `old`)
					);

					// this.changetableval(
					// 	`xfs_7_${num}_5`,
					// 	`tableDataV_I`,
					// 	this.gettableval(`xfs_7_${num}_5`, `tableDataV_I`) <= this.gettableval(`xfs_7_${num}_3`,
					// 		`tableDataV_I`) ? this.gettableval(`xfs_7_${num}_5`, `tableDataV_I`) : this.gettableval(
					// 		`xfs_7_${num}_3`, `tableDataV_I`)
					// );
					this.xfs_1_1000_5();
					this.xfs_7_4_5();
				}
				if (code == 6) {
					this.xfs_0_1000_6()
					this.changetableval(
						`xfs_1_${num}_11`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_6`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_7`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_8`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_9`, `tableDataII_I`)) * (this.gettableval(`xfs_1_${num}_10`,
							`tableDataII_I`) * 0.01)
					);
					if (num > 1) {
						this.changetableval(
							`xfs_3_${num}_8`,
							`tableDataIII_I`,
							this.gettableval(`xfs_3_${num}_4`, `tableDataIII_I`) * (this.gettableval(`xfs_3_${num}_5`,
								`tableDataIII_I`) * 0.01) + this.gettableval(`xfs_3_${num}_7`, `tableDataIII_I`) * this
							.gettableval(`xfs_3_${num}_6`, `tableDataIII_I`)
						);
					}
					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_I`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_I`) * this.gettableval(`xfs_4_${num}_5`,
							`tableDataIV_I`) + this.gettableval(`xfs_4_${num}_4`, `tableDataIV_I`) * (this
							.gettableval(`xfs_4_${num}_6`, `tableDataIV_I`) * 0.01)
					);
					this.changetableval(
						`xfs_4_${num}_7`,
						`tableDataIV_II`,
						this.gettableval(`xfs_4_${num}_3`, `tableDataIV_II`) + this.gettableval(
							`xfs_4_${num}_4`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_5`, `tableDataIV_II`) - this.gettableval(
							`xfs_4_${num}_6`, `tableDataIV_II`)
					);

					this.changetableval(
						`xfs_0_1003_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_1_1000_19`, `tableDataII_I`) + 0
						// this.gettableval(`xfs_1_1000_19`, `tableDataII_I`)+this.gettableval(`xfs_2_6_6`, `tableDataIII_I`)
					);
					this.changetableval(
						`xfs_0_1005_1`,
						`tableDataI_II`,
						Math.min((this.gettableval(`xfs_0_1000_6`, `tableDataI_I`) - this.gettableval(`xfs_0_1001_1`,
							`tableDataI_II`)), this.gettableval(`xfs_0_1004_1`, `tableDataI_II`))
					);
					this.changetableval(
						`xfs_0_1008_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_0_1000_6`, `tableDataI_I`) - this.gettableval(`xfs_0_1001_1`,
							`tableDataI_II`) - this.gettableval(`xfs_0_1005_1`, `tableDataI_II`) - this.gettableval(
							`xfs_0_1007_1`, `tableDataI_II`)
					);
					this.changetableval(
						`xfs_0_${num}_6C`,
						`tableDataI_I`,
						this.gettableval(`xfs_0_${num}_6`, `tableDataI_I`) + this.gettableval(`xfs_0_${num}_6C`,
							`tableDataI_I`, `old`)
					);
				}
				if (code == "6C") {
					this.xfs_0_1000_6C()
				}
				if (code == 7) {
					this.changetableval(
						`xfs_7_${num}_8`,
						`tableDataV_I`,
						(this.gettableval(`xfs_7_${num}_3`, `tableDataV_I`) - this.gettableval(`xfs_7_${num}_5`,
							`tableDataV_I`)) * (this.gettableval(`xfs_7_${num}_7`, `tableDataV_I`) * 0.01)
					);
					this.changetableval(
						`xfs_1_${num}_11`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_6`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_7`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_8`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_9`, `tableDataII_I`)) * (this.gettableval(`xfs_1_${num}_10`,
							`tableDataII_I`) * 0.01)
					);
					if (num > 1) {
						this.changetableval(
							`xfs_3_${num}_8`,
							`tableDataIII_I`,
							this.gettableval(`xfs_3_${num}_4`, `tableDataIII_I`) * (this.gettableval(`xfs_3_${num}_5`,
								`tableDataIII_I`) * 0.01) + this.gettableval(`xfs_3_${num}_7`, `tableDataIII_I`) * this
							.gettableval(`xfs_3_${num}_6`, `tableDataIII_I`)
						);
					}

				}
				if (code == 8) {
					this.changetableval(
						`xfs_1_${num}_11`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_6`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_7`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_8`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_9`, `tableDataII_I`)) * (this.gettableval(`xfs_1_${num}_10`,
							`tableDataII_I`) * 0.01)
					);
					this.xfs_3_1000_8();
					this.xfs_7_4_8();
					this.changetableval(
						`xfs_7_${num}_10`,
						`tableDataV_I`,
						this.gettableval(`xfs_7_${num}_3`, `tableDataV_I`) - this.gettableval(`xfs_7_${num}_5`,
							`tableDataV_I`) - this.gettableval(`xfs_7_${num}_8`, `tableDataV_I`) - this.gettableval(
							`xfs_7_${num}_9`, `tableDataV_I`)
					);
					this.changetableval(
						`xfs_0_1001_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_3_1000_8`, `tableDataIII_I`)
					);
				}
				if (code == 9) {
					this.changetableval(
						`xfs_7_${num}_10`,
						`tableDataV_I`,
						this.gettableval(`xfs_7_${num}_3`, `tableDataV_I`) - this.gettableval(`xfs_7_${num}_5`,
							`tableDataV_I`) - this.gettableval(`xfs_7_${num}_8`, `tableDataV_I`) - this.gettableval(
							`xfs_7_${num}_9`, `tableDataV_I`)
					);
					this.changetableval(
						`xfs_1_${num}_11`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_6`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_7`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_8`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_9`, `tableDataII_I`)) * (this.gettableval(`xfs_1_${num}_10`,
							`tableDataII_I`) * 0.01)
					);
					this.xfs_7_4_9();
				}
				if (code == 10) {
					this.changetableval(
						`xfs_1_${num}_11`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_6`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_7`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_8`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_9`, `tableDataII_I`)) * (this.gettableval(`xfs_1_${num}_10`,
							`tableDataII_I`) * 0.01)
					);
					this.changetableval(
						`xfs_0_1009_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_7_1_10`, `tableDataV_I`)
					);
					this.changetableval(
						`xfs_0_1010_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_7_2_10`, `tableDataV_I`)
					);
					this.changetableval(
						`xfs_0_1011_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_7_3_10`, `tableDataV_I`)
					);
					this.xfs_7_4_10();
				}
				if (code == 11) {
					this.xfs_1_1000_11();
					this.changetableval(
						`xfs_1_${num}_19`,
						`tableDataII_I`,
						this.gettableval(`xfs_1_${num}_5`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_11`,
							`tableDataII_I`) + this.gettableval(`xfs_1_${num}_18`, `tableDataII_I`)
					);
				}
				if (code == 12) {
					this.changetableval(
						`xfs_1_${num}_18`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_12`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_13`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_14`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_15`, `tableDataII_I`)) * this
						.gettableval(`xfs_1_${num}_16`, `tableDataII_I`)
					);
				}
				if (code == 13) {
					this.changetableval(
						`xfs_1_${num}_18`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_12`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_13`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_14`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_15`, `tableDataII_I`)) * this
						.gettableval(`xfs_1_${num}_16`, `tableDataII_I`)
					);
				}
				if (code == 14) {
					this.changetableval(
						`xfs_1_${num}_18`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_12`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_13`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_14`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_15`, `tableDataII_I`)) * this
						.gettableval(`xfs_1_${num}_16`, `tableDataII_I`)
					);
				}
				if (code == 15) {
					this.changetableval(
						`xfs_1_${num}_18`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_12`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_13`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_14`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_15`, `tableDataII_I`)) * this
						.gettableval(`xfs_1_${num}_16`, `tableDataII_I`)
					);
				}
				if (code == 16) {
					this.changetableval(
						`xfs_1_${num}_18`,
						`tableDataII_I`,
						(this.gettableval(`xfs_1_${num}_12`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_13`,
								`tableDataII_I`) - this.gettableval(`xfs_1_${num}_14`, `tableDataII_I`) - this
							.gettableval(`xfs_1_${num}_15`, `tableDataII_I`)) * this
						.gettableval(`xfs_1_${num}_16`, `tableDataII_I`)
					);
				}
				if (code == 17) {}
				if (code == 18) {
					this.changetableval(
						`xfs_1_${num}_19`,
						`tableDataII_I`,
						this.gettableval(`xfs_1_${num}_5`, `tableDataII_I`) + this.gettableval(`xfs_1_${num}_11`,
							`tableDataII_I`) + this.gettableval(`xfs_1_${num}_18`, `tableDataII_I`)
					);
					this.xfs_1_1000_18()
				}
				if (code == 19) {
					this.changetableval(
						`xfs_0_1003_1`,
						`tableDataI_II`,
						this.gettableval(`xfs_1_1000_19`, `tableDataII_I`) + 0
						// this.gettableval(`xfs_1_1000_19`, `tableDataII_I`)+this.gettableval(`xfs_2_6_6`, `tableDataIII_I`)
					);
					this.xfs_1_1000_19()
				}
			},

			xfs_0_1000_6() {
				let total = 0;
				this.tableDataI_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '_6' && item[key].cellCode != `xfs_0_1000_6`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_0_1000_6`, `tableDataI_I`, total);
			},
			xfs_0_1000_6C() {
				let total = 0;
				this.tableDataI_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 3, key.length);
						if (Code == '_6C' && item[key].cellCode != `xfs_0_1000_6C`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_0_1000_6C`, `tableDataI_I`, total);
			},
			xfs_1_1000_5() {
				let total = 0;
				this.tableDataII_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '_5' && item[key].cellCode != `xfs_1_1000_5`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_1_1000_5`, `tableDataII_I`, total);
			},
			xfs_1_1000_11() {
				let total = 0;
				this.tableDataII_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '11' && item[key].cellCode != `xfs_1_1000_11`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_1_1000_11`, `tableDataII_I`, total);
			},
			xfs_1_1000_18() {
				let total = 0;
				this.tableDataII_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '18' && item[key].cellCode != `xfs_1_1000_18`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_1_1000_18`, `tableDataII_I`, total);
			},
			xfs_1_1000_19() {
				let total = 0;
				this.tableDataII_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '19' && item[key].cellCode != `xfs_1_1000_19`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_1_1000_19`, `tableDataII_I`, total);
			},
			xfs_3_1000_8() {
				let total = 0;
				this.tableDataIII_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '_8' && item[key].cellCode != `xfs_3_1000_8` && item[key].cellCode !=
							`xfs_3_1_8`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_3_1000_8`, `tableDataIII_I`, total);
			},
			xfs_7_4_3() {
				let total = 0;
				this.tableDataV_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '_3' && item[key].cellCode != `xfs_7_4_3`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_7_4_3`, `tableDataV_I`, total);
			},
			xfs_7_4_5() {
				let total = 0;
				this.tableDataV_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '_5' && item[key].cellCode != `xfs_7_4_5`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_7_4_5`, `tableDataV_I`, total);
			},
			xfs_7_4_8() {
				let total = 0;
				this.tableDataV_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '_8' && item[key].cellCode != `xfs_7_4_8`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_7_4_8`, `tableDataV_I`, total);
			},
			xfs_7_4_9() {
				let total = 0;
				this.tableDataV_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '_9' && item[key].cellCode != `xfs_7_4_9`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_7_4_9`, `tableDataV_I`, total);
			},
			xfs_7_4_10() {
				let total = 0;
				this.tableDataV_I.map((item) => {
					Object.keys(item).map((key) => {
						let Code = key.substring(key.length - 2, key.length);
						if (Code == '10' && item[key].cellCode != `xfs_7_4_10`) {
							total += Number(item[key].cellVal);
						}
					});
				});
				this.changetableval(`xfs_7_4_10`, `tableDataV_I`, total);
			},
			gettableval(changecode, table, old) {
				var head = '';
				if (table == `tableDataI_I` || table == `tableDataI_II`) {
					head = 'IHead';
				}
				if (table == `tableDataII_I`) {
					head = 'IIHead';
				}
				if (table == `tableDataIII_I`) {
					head = 'IIIHead';
				}
				if (table == `tableDataIV_I`) {
					head = 'IIIIHead';
				}
				if (table == `tableDataIV_II`) {
					head = 'IIIIIHead';
				}
				if (table == `tableDataV_I`) {
					head = 'IIIIIIHead';
				}
				if (table == `tableDataVI_I` || table == `tableDataVI_II`) {
					head = 'IIIIIIIHead';
				}
				var a;
				if (this[table] && this[head]) {
					for (let i = 0; i < this[table].length; i++) {
						for (let j = 0; j < this[head].length; j++) {
							if (
								this[table][i][this[head][j]] &&
								this[table][i][this[head][j]].cellCode &&
								this[table][i][this[head][j]].cellVal &&
								this[table][i][this[head][j]].cellCode == changecode
							) {
								if (old) {
									if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
										a = 0;
									} else {
										a = parseFloat(this[table][i][this[head][j]].goujgxValue);
									}
								} else {
									if (this[table][i][this[head][j]].cellVal == '-') {
										a = 0;
									} else {
										a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
									}
								}
								break;
							}
						}
					}
				}
				a = a || 0;
				if (
					changecode == 'sdsA_1_18_1' ||
					changecode == 'sdsA_1_19_1' ||
					changecode == 'sdsA_1_20_1' ||
					changecode == 'sdsA_1_20_2' ||
					changecode == 'sdsA_1_23.2_2'
				) {
					if (!a < 1) {
						a = a * 0.01;
					}
				}
				return a;
			},
			changetableval(changecode, table, newval, checkq, digit) {
				var newval = newval || 0;
				if (digit) {
					newval = this.toFixed(newval, digit);
				} else {
					newval = this.toFixed(newval, 2);
				}
				var head = '';
				if (table == `tableDataI_I` || table == `tableDataI_II`) {
					head = 'IHead';
				}
				if (table == `tableDataII_I`) {
					head = 'IIHead';
				}
				if (table == `tableDataIII_I`) {
					head = 'IIIHead';
				}
				if (table == `tableDataIV_I`) {
					head = 'IIIIHead';
				}
				if (table == `tableDataIV_II`) {
					head = 'IIIIIHead';
				}
				if (table == `tableDataV_I`) {
					head = 'IIIIIIHead';
				}
				if (table == `tableDataVI_I` || table == `tableDataVI_II`) {
					head = 'IIIIIIIHead';
				}
				for (let i = 0; i < this[table].length; i++) {
					for (let j = 0; j < this[head].length; j++) {
						if (
							this[table][i][this[head][j]] &&
							this[table][i][this[head][j]].cellCode &&
							typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
							typeof this[table][i][this[head][j]].cellVal != undefined &&
							this[table][i][this[head][j]].cellCode == changecode
						) {
							if (this[table][i][this[head][j]].cellVal != newval) {
								if (this.suosq.substring(4, 6) < 5 && checkq) {
									this[table][i][this[head][j]].cellVal = '';
								} else {
									this[table][i][this[head][j]].cellVal = newval + '';
								}
								this.inputblur({
									cellCode: changecode,
									cellVal: newval
								});
								break;
							}
						}
					}
				}
			}
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>